<template>
  <div id="app">
    <transition name="fade" mode="out-in" :appear="true">
      <router-view></router-view>
    </transition>
    <div class="ui text footer-logo container">
      <img src="./assets/footer-logo.svg" class="ui centered medium image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
};
</script>

<style>
@import '//cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.6/semantic.min.css';
@import url('https://fonts.googleapis.com/css?family=Ubuntu:400,500,700');

html.no-rgba,
html.no-textshadow,
html.no-flexbox {
  background: #ffffff !important;
  color: #000000 !important;
}
.no-rgba .old-browser,
.no-textshadow .old-browser,
.no-flexbox .old-browser {
  display: block !important;
}
.no-rgba .old-browser p,
.no-textshadow .old-browser p,
.no-flexbox .old-browser p {
  padding: 20px;
  font-family: Arial, Verdana, sans-serif;
  text-shadow: none;
  font-size: 14px;
  color: #000000;
}
.no-rgba #app,
.no-textshadow #app,
.no-flexbox #app {
  display: none;
}
html {
  background-color: #24252d;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
body {
  background: transparent;
  min-width: 320px;
}
html:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(45deg, #6e436c 25%, #2a4584 75%);
  background-size: 256px, cover;
  background-position: center, center;
  background-repeat: repeat, no-repeat;
}
html:before,
html:after {
  content: '';
  display: block;
  position: fixed;
  bottom: -5vh;
  left: -5vw;
  width: 110vw;
  height: 110vh;
  pointer-events: none;
  -moz-transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  z-index: -1;
}
.zero-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(45deg, #6e436c 25%, #2a4584 75%);
}
.one-bg:before {
  background-image: url(./assets/overlay.png),
    radial-gradient(ellipse farthest-corner at center, #bc2213 0%, #4b0e08 140%);
}
.two-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(to top, #537895 0%, #09203f 100%);
}
.three-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.four-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(60deg, #29323c 0%, #485563 100%);
}
.five-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(to right, #6a11cb 0%, #2575fc 100%);
}
.six-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.seven-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%);
}
.eight-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(-20deg, #616161 0%, #9bc5c3 100%);
}
.nine-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(-225deg, #473b7b 0%, #3584a7 51%, #30d2be 100%);
}
.ten-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(-225deg, #ff057c 0%, #8d0b93 50%, #321575 100%);
}
.eleven-bg:before {
  background-image: url(./assets/overlay.png),
    linear-gradient(-225deg, #3d4e81 0%, #5753c9 48%, #6e7ff3 100%);
}
::selection,
input::selection {
  color: white;
  background: black;
}
@media only screen and (min-width: 767px) {
  #app {
    padding: 2em;
    padding-bottom: 5em;
  }
}
@media only screen and (max-width: 767px) {
  #app {
    padding-top: 2em;
    padding-bottom: 5em;
  }
}
body,
p,
.header,
.ui.button,
.ui.header,
.ui.header .sub.header,
.ui.menu .item,
.ui.list .list > .item .header,
.ui.list > .item .header,
.ui.form .field > label,
.ui.label,
.ui.text.container,
.ui.statistic > .value,
.ui.statistics .statistic > .value,
.ui.statistic > .label,
.ui.statistics .statistic > .label {
  font-family: 'Ubuntu', Arial, serif;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.87);
  text-shadow: -1px 2px 1px rgba(13, 13, 13, 0.1);
}
a {
  color: #f2711c;
}
a:hover {
  color: #b94f09;
}
.ui.form input:not([type]),
.ui.form input[type='text'],
.ui.form input[type='email'],
.ui.form input[type='search'],
.ui.form input[type='password'],
.ui.form input[type='date'],
.ui.form input[type='datetime-local'],
.ui.form input[type='tel'],
.ui.form input[type='time'],
.ui.form input[type='file'],
.ui.form input[type='url'],
.ui.form input[type='number'] {
  font-family: 'Ubuntu', Arial, serif;
  font-weight: normal;
}
.ui.icon.input > i.icon {
  text-shadow: none;
}
.ui.segment,
.ui.attached.segment,
.ui.menu {
  background: rgba(0, 0, 0, 0.25);
}
.ui.segments,
.ui.segment,
.ui.attached.segment,
.ui.menu,
.ui.divided.list > .item,
.ui.table {
  box-shadow: none;
  border: none;
}
.ui.padded.segment {
  padding-top: 2em;
  padding-bottom: 2em;
}
.ui.label,
.ui.horizontal.label,
.ui.horizontal.labels .label {
  font-size: 1rem;
  padding: 0.45em 0.533em 0.3em;
  text-transform: uppercase;
  text-shadow: none;
}
.ui.statistic > .value {
  font-size: 8rem !important;
  margin-bottom: 1rem;
}
.ui.statistic > .label {
  font-size: 2rem !important;
  line-height: normal;
}
@media only screen and (max-width: 991px) {
  .ui.huge.statistic > .value {
    font-size: 4.5rem !important;
  }
  .ui.huge.statistic > .label {
    font-size: 1.5rem !important;
  }
}
.ui.header {
  font-size: 4rem;
}
.ui.message,
.ui.message .header {
  text-shadow: none;
  font-size: 1.4rem;
}
.alertify-logs {
  font-size: 1.5rem;
  text-shadow: none;
  z-index: 9999;
}
.ui.button {
  text-shadow: none;
  color: black;
}
/* -> Animations <- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.15, 1.15, 1.15);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulseStrong {
  from {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.4, 1.4, 1.4);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.pulse.animated {
  animation-name: pulse;
  animation-duration: 0.4s;
}
.pulseStrong.animated {
  animation-name: pulseStrong;
  animation-duration: 0.4s;
}
.footer-logo {
  margin-top: 3em;
}
</style>
